import { Injectable } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Entry } from 'contentful';
import { ContentFulModel } from 'src/app/shared/models/contentfulmodel';
import { BehaviorSubject } from 'rxjs';
import { PageId } from 'src/app/shared/utilities/pageids.enum';
import { MetaService } from 'src/app/shared/services/meta.service';

@Injectable({
  providedIn: 'root',
})
export class ReservePageService {
  constructor(
    private contentful: ContentfulService,
    private meta: MetaService
  ) {}

  ReserveData: any;

  getReservePageData() {
    this.contentful
      .getEntries(
        Object.assign({
          content_type: PageId.solutionsPage,
          include: 10,
        })
      )
      .then(res => {
        let mod = res.items as Entry<any>[];
        this.ReserveData = mod.filter(
          x => x?.fields['id'] == PageId.solutionsReservePage
        );
      });
  }
}
